// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2lx4T","options":"AnswerScale_options__2aBp9","selected":"AnswerScale_selected__dERVL"};